import { useDispatch } from 'react-redux'
import type { AppDispatch } from './configureStore'

/**
 * `useDispatch` bound to the store's own dispatch, so it accepts thunks.
 *
 * The plain `useDispatch` is typed to `UnknownAction` in react-redux 9 — under
 * react-redux 7 it returned `Dispatch<any>`, which silently accepted the thunks
 * this app dispatches. Use this anywhere a thunk (rather than a plain action) is
 * dispatched; `dispatch` itself behaves identically at runtime either way.
 *
 * There is deliberately no `useAppSelector` counterpart: `src/types/react-redux.d.ts`
 * already makes a bare `useSelector(state => …)` infer `RootState`.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
